import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { json } from "d3-fetch"
import ChatService from "services/ChatService"

export const getChats = createAsyncThunk(
  "chat/getChats",
  async ({ page, limit, search = "" }, { rejectWithValue }) => {
    try {
      const response = await ChatService.getChats({ page, limit, search })
      console.log("respo,nse " + JSON.stringify(response, null, 2))
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  },
)

export const getChatById = createAsyncThunk(
  "chat/getChatById",
  async ({ chatId }, { rejectWithValue }) => {
    try {
      const response = await ChatService.getChatById(chatId)
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  },
)

export const getMessages = createAsyncThunk(
  "chat/getMessages",
  async ({ chatId, page, limit }, { rejectWithValue }) => {
    try {
      const response = await ChatService.getMessages(chatId, page, limit)
      return { ...response, page }
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  },
)

export const sendMessage = createAsyncThunk(
  "chat/sendMessage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ChatService.sendMessage(data)
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  },
)

export const createChat = createAsyncThunk(
  "chat/createChat",
  async ({ clientId }, { rejectWithValue }) => {
    try {
      const response = await ChatService.createChat(clientId)
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  },
)

export const countUnread = createAsyncThunk(
  "chat/countUnread",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ChatService.countUnread()
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data)
    }
  },
)

const initialState = {
  chats: { loading: false, data: [], error: null },
  chatById: { loading: false, data: null, error: null },
  messages: { loading: false, data: [], total: 0, error: null },
  send: { loading: false, data: null, error: null },
  create: { loading: false, data: null, error: null },
  unread: {
    loading: false,
    count: 0,
    clients: [],
    chats: [],
    error: null,
  },
}

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    clearChatState: () => initialState,

    updateChatsList(state, action) {
      const newChat = action.payload
      const chats = state.chats.data

      const index = chats.findIndex((c) => c._id === newChat._id)

      if (index !== -1) {
        chats.splice(index, 1)
      } else {
        if (chats.length >= 1) {
          chats.pop()
        }
      }

      chats.unshift(newChat)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChats.pending, (state) => {
        state.chats.loading = true
      })
      .addCase(getChats.fulfilled, (state, action) => {
        state.chats.loading = false
        state.chats.data = action.payload.chats
      })
      .addCase(getChats.rejected, (state, action) => {
        state.chats.loading = false
        state.chats.error = action.payload
      })

    /* GET CHAT BY ID */
    builder
      .addCase(getChatById.pending, (state) => {
        state.chatById.loading = true
      })
      .addCase(getChatById.fulfilled, (state, action) => {
        state.chatById.loading = false
        state.chatById.data = action.payload
      })
      .addCase(getChatById.rejected, (state, action) => {
        state.chatById.loading = false
        state.chatById.error = action.payload
      })

    /* GET MESSAGES */
    builder
      .addCase(getMessages.pending, (state) => {
        state.messages.loading = true
      })
      .addCase(getMessages.fulfilled, (state, action) => {
        state.messages.loading = false
        const { messages, total, page } = action.payload
        if (page === 1) {
          state.messages.data = messages
        } else {
          // Filtrer les doublons au cas où
          const existingIds = new Set(state.messages.data.map((m) => m._id))
          const newMessages = messages.filter((m) => !existingIds.has(m._id))
          state.messages.data = [...state.messages.data, ...newMessages]
        }
        state.messages.total = total
      })
      .addCase(getMessages.rejected, (state, action) => {
        state.messages.loading = false
        state.messages.error = action.payload
      })

    /* SEND MESSAGE */
    builder
      .addCase(sendMessage.pending, (state) => {
        state.send.loading = true
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.send.loading = false
        state.send.data = action.payload.data
        // push instantly
        state.messages.data.unshift(action.payload.data)
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.send.loading = false
        state.send.error = action.payload
      })

    /* CREATE CHAT */
    builder
      .addCase(createChat.pending, (state) => {
        state.create.loading = true
      })
      .addCase(createChat.fulfilled, (state, action) => {
        state.create.loading = false
        state.create.data = action.payload.data
      })
      .addCase(createChat.rejected, (state, action) => {
        state.create.loading = false
        state.create.error = action.payload
      })

    /* COUNT UNREAD */
    builder
      .addCase(countUnread.pending, (state) => {
        state.unread.loading = true
      })
      .addCase(countUnread.fulfilled, (state, action) => {
        state.unread.loading = false
        state.unread.count = action.payload.count
        state.unread.clients = action.payload.clients
        state.unread.chats = action.payload.chats
      })
      .addCase(countUnread.rejected, (state, action) => {
        state.unread.loading = false
        state.unread.error = action.payload
      })
  },
})

export const { clearChatState, updateChatsList } = chatSlice.actions
export default chatSlice.reducer
